import React, { PropTypes } from 'react'
import _ from 'lodash'

const ErrorMessageUser = ({ error, flatternedFieldErrors }) => (
  <div>
    {error.detail.message && error.detail.message}
    {flatternedFieldErrors &&
      <ul>
        {_.map(flatternedFieldErrors, (message, i) => <li key={i}>{message}</li>)}
      </ul>
    }
  </div>
)

ErrorMessageUser.propTypes = {
  error: PropTypes.object,
  flatternedFieldErrors: PropTypes.array,
}

export default ErrorMessageUser



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message-user/error-message-user.js
 **/